// TODO ужасная функция, надо сделать универсальнее
export function filterNonEmptyKeys<T extends Record<string, any>>(obj: T): Partial<T> {

  const result = Object.fromEntries(
    Object.entries(obj).filter(([key, value]) => value || value === 0)
  ) as Partial<T>;

  return result;
};